<template>
  <b-form-group
    label="Süre"
    label-for="minutes"
  >
    <validation-provider
      #default="{ errors }"
      name="Süre"
      rules="required"
    >
      <b-input-group>
        <b-form-input
          id="minutes"
          v-model="dataList[keyNumber].minutes"
          placeholder="Süre"
        />
        <b-input-group-append is-text>
          dk
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'MinutesText',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['productTimes/dataList']
    },
  },
}
</script>
